export const RATES = {
  // world in data
  "Armenia": 813,
  "Australia": 123449,
  "New South Wales, Australia": 39089,
  "Queensland, Australia": 27000,
  "Western Australia, Australia": 8603,
  "Victoria, Australia": 19337,
  "South Australia, Australia": 16717,
  "Tasmania, Australia": 807,
  "Austria": 15613,
  "Bahrain": 18645,
  "Belarus": 19000,
  "Belgium": 18360,
  "Bosnia and Herzegovina": 717,
  "Brazil": 2927,
  "Canada": 38482,
  "Alberta, Canada": 17013,
  "British Columbia, Canada": 6326,
  "National lab, Canada": 54956,
  "New Brunswick, Canada": 520,
  "Northwest Territories, Canada": 222,
  "Nova Scotia, Canada": 1561,
  "Ontario, Canada": 19511,
  "Quebec, Canada": 10451,
  "Saskatchewan, Canada": 2561,
  "China - Guangdong": 320000,
  "Colombia": 5034,
  "Costa Rica": 1039,
  "Croatia": 1264,
  "Czechia": 11619,
  "Denmark": 13599,
  "Ecuador": 1964,
  "Estonia": 2812,
  "Faroe Islands": 1641,
  "Finland": 7300,
  "France, France": 36747,
  "Germany": 167000,
  "Grenada": 18,
  "Hong Kong": 5271,
  "Hungary": 3447,
  "Iceland": 9786,
  "India": 15404,
  "Indonesia": 2365,
  "Iran": 80000,
  "Ireland": 6600,
  "Israel": 17641,
  "Italy": 206886,
  "Japan": 18963,
  "Kuwait": 120000,
  "Kazakhstan": 5093,
  "Kyrgyzstan": 1545,
  "Latvia": 4446,
  "Lithuania": 1466,
  "Malaysia": 13876,
  "Malta": 889,
  "Mexico": 1533,
  "Netherlands, Netherlands": 6000,
  "New Zealand": 584,
  "Norway": 43735,
  "Pakistan": 1979,
  "Palestine": 2519,
  "Panama": 1455,
  "Peru": 4298,
  "Philippines": 1395,
  "Poland": 15084,
  "Qatar": 8400,
  "Romania": 8915,
  "Russia": 156060,
  "Slovakia": 3247,
  "Slovenia": 10980,
  "Spain": 30000,
  "South Africa": 7425,
  "South Korea": 327509,
  "Sweden": 14300,
  "Switzerland": 4000,
  "Taiwan": 21396,
  "Thailand": 8710,
  "Turkey": 2900,
  "Ukraine": 450,
  "United Arab Emirates": 125000,
  "United Kingdom": 66976,
  "United States": 182697,
  "Vietnam": 17459,

  // https://docs.google.com/spreadsheets/u/2/d/e/2PACX-1vRwAqp96T9sYYq2-i7Tj0pvTf6XVHjDSMIKBdZHXiCGGdNC0ypEU9NbngS8mxea55JuCFuua1MUeOj5/pubhtml#
  "Alaska, US":	        772,
  "Alabama, US":        152,
  "Arkansas, US":       839,
  "Arizona, US":        516,
  "California, US":     12528,
  "Colorado, US":       3680,
  "Connecticut, US":    2300,
  "DC":                 583,              /* unkown */
  "Delaware, US":       81,
  "Florida, US":        8239,
  "Georgia, US":        3064,
  "Guam":               123,
  "Hawaii, US":         170,
  "Iowa, US":           1117,
  "Idaho, US":          911,
  "Illinois, US":       6247,
  "Indiana, US":        833,
  "Kansas, US":         472,
  "Kentucky, US":       768,
  "Louisiana, US":      2765,
  "Massachusetts, US":  5277,
  "Maryland, US":       284,
  "Maine, US":          2337,
  "Michigan, US":       2856,
  "Minnesota, US":      4090,
  "Missouri, US":       442,
  "MP": 0,               /* unkown */
  "Mississippi, US":    835,
  "Montana, US":        1166,
  "North Carolina, US": 5276,
  "North Dakota, US":   1169,
  "Nebraska, US":       394,
  "New Hampshire, US":  1970,
  "New Jersey, US":     1661,
  "New Mexico, US":     3828,
  "Nevada, US":         2508,
  "New York, US":       45437,
  "Ohio, US":           387,
  "Oklahoma, US":       757,
  "Oregon, US":         2550,
  "Pennsylvania, US":   4137,
  "Puerto Rico":        235,
  "Rhode Island, US":   1218,
  "South Carolina, US": 1407,
  "South Dakota, US":   973,
  "Tennessee, US":      3643,
  "Texas, US":          6522,
  "Utah, US":           2560,
  "Virginia, US":       2790,
  "Virgin Islands":     6,
  "Vermont, US":        808,
  "Washington, US":     23243,
  "Wisconsin, US":      4967,
  "West Virginia, US":  343,
  "Wyoming, US":        461
};